import './App.css';
import Header from './components/Header.js';
import Rights from './Rights.js';
import HomePage from './pages/HomePage.js'
import ProjectPage from './pages/ProjectPage.js'
import ContactPage from './pages/ContactPage.js'
import {BrowserRouter, Routes, Route} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import BackToTop from './components/ui/BackToTop.js';
import useProjectPage from "./hooks/useProjectPage.js";
import AssistantAgent from './components/ai/AssistantAgent.js';

function App() {
  useProjectPage();
  return(
    <BrowserRouter>
      <Header/>
      <ToastContainer position="top-right" autoClose={3000}/>
      <Routes>
          <Route path="/"element={<HomePage/>}/>
          <Route path="/project"element={<ProjectPage/>}/>
          <Route path="/contact"element={<ContactPage/>}/>
      </Routes>
      <Rights/>
      <AssistantAgent/>
      <BackToTop/>
    </BrowserRouter>
  );
}

export default App;
